export default () => {
  const actions = [
    {
      name: "change_size",
      icon: "arrow-expand-horizontal",
      actions: [
        {
          name: "increase_size",
          actions: [
            { name: "increase_25" },
            { name: "increase_50" },
            { name: "increase_75" },
          ]
        },
        {
          name: "decrease_size",
          actions: [
            { name: "decrease_25" },
            { name: "decrease_50" },
            { name: "decrease_75" },
          ]
        },
      ]
    },
    {
      name: "change_tone",
      icon: "text-box-settings",
      actions: [
        { name: "tone_official" },
        { name: "tone_friendly" },
        { name: "tone_motivational" },
        { name: "tone_humorous" },
        { name: "tone_dramatic" },
        { name: "tone_calm" },
        { name: "tone_enthusiastic" },
        { name: "tone_sarcastic" },
        { name: "tone_scientific" },
        { name: "tone_retro" },
      ]
    },
    {
      name: "add_emoji",
      icon: "smiley-in-love"
    },
    {
      name: "translate",
      icon: "translate",
      actions: [
        { "name": "translate_to_en", "icon": "\uD83C\uDDEC\uD83C\uDDE7" }, // 🇬🇧
        { "name": "translate_to_es", "icon": "\uD83C\uDDEA\uD83C\uDDF8" }, // 🇪🇸
        { "name": "translate_to_zh", "icon": "\uD83C\uDDE8\uD83C\uDDF3" }, // 🇨🇳
        { "name": "translate_to_de", "icon": "\uD83C\uDDE9\uD83C\uDDEA" }, // 🇩🇪
        { "name": "translate_to_pt", "icon": "\uD83C\uDDF5\uD83C\uDDF9" }, // 🇵🇹
        { "name": "translate_to_tr", "icon": "\uD83C\uDDF9\uD83C\uDDF7" }, // 🇹🇷
        { "name": "translate_to_ru", "icon": "\uD83C\uDDF7\uD83C\uDDFA" }, // 🇷🇺
        { "name": "translate_to_kz", "icon": "\uD83C\uDDF0\uD83C\uDDFF" }, // 🇰🇿
        { "name": "translate_to_pl", "icon": "\uD83C\uDDF5\uD83C\uDDF1" }, // 🇵🇱
      ]
    },
    {
      name: "make_rewrite",
      icon: "pencil-ai",
    },
    {
      name: "check_errors",
      icon: "spelling",
    },
  ];

  const translate = (key, action) => {
    const text = i18n.t(`assistant.prompts.${key}.${action}`);
    return text.startsWith("[missing") ? null : text;
  }

  const transformActions = (collection) => {
    return collection.map(({ name, icon = null, actions = [] }) => ({
      name,
      icon,
      title: translate(name, 'title'),
      prompt: translate(name, 'prompt'),
      actions: actions.length > 0 ? transformActions(actions) : [],
    }));
  };

  return transformActions(actions);
}
